import Breadcrumbs from "@/components/feature/Breadcrumbs";

interface Crumb {
  label: string;
  to?: string;
}

interface PageHeaderProps {
  crumbs: Crumb[];
  eyebrow?: string;
  title: string;
  desc?: string;
}

export default function PageHeader({ crumbs, eyebrow, title, desc }: PageHeaderProps) {
  return (
    <section className="border-b border-foreground-950/10 bg-background-100 paper-grain">
      <div className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
        <Breadcrumbs items={crumbs} />
        {eyebrow && (
          <span className="mt-5 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" aria-hidden="true"></span>
            {eyebrow}
          </span>
        )}
        <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
          {title}
        </h1>
        {desc && <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
    </section>
  );
}